import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const REGISTER_URL = "https://app.NOBILENEXT.com/register";

const SLIDER_SETTINGS = {
  dots: false, // Desativa os pontos, já que há apenas um slide
  infinite: false, // Desativa o loop infinito
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false, // Desativa o autoplay, já que há apenas uma imagem
  arrows: false, // Desativa as setas, já que não há navegação
  adaptiveHeight: false,
  centerMode: false,
  variableWidth: false,
};

const SLIDES = [
  {
    image: "/img/header.webp",
    title: "Soluções Financeiras e Gestão de Funding",
    subtitle: "e Gestão de Funding",
  },
];

// Função utilitária para abrir URL em nova aba
const openInNewTab = () => {
  window.open(REGISTER_URL, "_blank", "noreferrer");
};

// Componente separado para cada slide
const SlideItem = ({ slide }) => (
  <div className="slide-wrapper">
    <div className="slide-image">
      <img
        src={slide.image}
        alt={slide.title}
        loading="lazy"
        className="slide-img"
      />
      <div className="overlay">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 col-xs-12 intro-text">
              <h1 className="upp">
                {" "}
                <span style={{ color: "#A64812" }}>
                  Soluções Financeiras
                </span>{" "}
                <span style={{ color: "#F2D857" }}>e Gestão de Funding</span>
              </h1>
              {/* <p className="subtitle m-top m-bottom">{slide.subtitle}</p> */}
              {/* <button className="btn btn-custom btn-lg" onClick={openInNewTab}>
                Abra sua conta
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

// Componente principal
export const Slidershow = () => (
  <div className="slideshow">
    <Slider {...SLIDER_SETTINGS}>
      {SLIDES.map((slide, index) => (
        <SlideItem key={index} slide={slide} />
      ))}
    </Slider>
  </div>
);
